import { useEffect, useState } from "react";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Copy } from "@phosphor-icons/react";

export default function Referrals() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/referrals/me").then((r) => setData(r.data)); }, []);

    if (!data) return <div className="min-h-screen flex items-center justify-center text-xs font-mono">LOADING…</div>;

    const link = `${window.location.origin}/register?ref=${data.code}`;
    const copy = () => {
        navigator.clipboard.writeText(link);
        toast.success("Referral link copied");
    };

    return (
        <div className="bg-paper min-h-screen">
            <Navbar />
            <main className="max-w-3xl mx-auto px-6 py-12">
                <p className="eyebrow mb-2">REFERRALS</p>
                <h1 className="h2 mb-2" data-testid="ref-title">Invite friends, earn 200 pts each.</h1>
                <p className="text-ink-600 text-sm mb-8">When your friend completes their first survey, you both get +200 pts ($2 each). Unlimited referrals.</p>

                <div className="card-base p-6 mb-10">
                    <div className="eyebrow mb-2">YOUR LINK</div>
                    <div className="flex flex-col sm:flex-row gap-2">
                        <input className="input-base flex-1 font-mono text-xs" value={link} readOnly data-testid="ref-link-input" />
                        <button onClick={copy} className="btn btn-ink" data-testid="ref-copy-btn"><Copy size={16} /> Copy</button>
                    </div>
                    <div className="mt-4 grid grid-cols-3 divide-x divide-ink-200 border border-ink-200">
                        <Stat label="Code" value={data.code} />
                        <Stat label="Awarded" value={data.awarded_count} />
                        <Stat label="Pending" value={data.pending_count} />
                    </div>
                </div>

                <p className="eyebrow mb-3">HISTORY</p>
                <div className="card-base">
                    {data.items.length === 0 && <div className="p-8 text-sm text-ink-600 text-center">No referrals yet.</div>}
                    {data.items.map((r) => (
                        <div key={r.id} className="flex items-center justify-between p-4 border-b border-ink-200 last:border-b-0" data-testid={`ref-row-${r.id}`}>
                            <div>
                                <div className="font-semibold text-sm">{r.referee?.name || r.referee?.email || "Pending"}</div>
                                <div className="text-xs text-ink-600">{r.referee?.email}</div>
                            </div>
                            <span className={`font-mono text-[10px] px-2 py-1 ${r.status === "awarded" ? "bg-success/15 text-success" : "bg-warning/15 text-warning"}`}>
                                {r.status === "awarded" ? "+200 PTS" : "PENDING"}
                            </span>
                        </div>
                    ))}
                </div>
            </main>
            <Footer />
        </div>
    );
}

function Stat({ label, value }) {
    return (
        <div className="px-4 py-3 text-center">
            <div className="font-mono text-2xl">{value}</div>
            <div className="text-[10px] uppercase tracking-wider text-ink-600">{label}</div>
        </div>
    );
}
